import { CONTROL_STATES_API } from 'constants/AppConstants';

export default async (moduleName, userId) => {
  try {
    const response = await fetch(`${CONTROL_STATES_API.replace(':userId', userId)}?moduleName=${moduleName}`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
